import {
    EVENTBRITE_CATEGORY_MAPPING,
    FILM_EVENTBRITE_CATEGORY,
    FOOD_AND_DRINK_EVENTBRITE_CATEGORY,
    FORMATTED_SUBCATEGORY_MAP,
    MUSIC_EVENTBRITE_CATEGORY,
    PERFORMING_EVENTBRITE_CATEGORY,
    SEASONAL_EVENTBRITE_CATEGORY,
    SUBCATEGORY_REFINEMENT_TO_KEY,
} from '@eventbrite/categories';

import { getExperiment } from '@eventbrite/statsig';
import React, { useEffect, useState } from 'react';
import {
    EVENTBRITE_FORMAT_MAPPING,
    PARTY_EVENTBRITE_FORMAT,
} from '../../../../discover/src/constants';
import { LISTING_NIGHTLIFE_NYE_TOUCHPOINT } from '../../constants';
import { NightlifePromoBanner } from '../NightlifePromoBanner/NightlifePromoBanner';
import { NYETouchpoint } from '../NYETouchpoint';

type TouchpointProps = {
    startHour: number;
    category?: string;
    subcategory?: string;
    format?: string;
    isMobile: boolean;
};

export const Touchpoint = ({
    startHour,
    category,
    subcategory,
    format,
    isMobile,
}: TouchpointProps) => {
    const [showTouchpoint, setShowTouchpoint] = useState(false);

    useEffect(() => {
        const variant = getExperiment(
            LISTING_NIGHTLIFE_NYE_TOUCHPOINT.experimentName,
            LISTING_NIGHTLIFE_NYE_TOUCHPOINT.param,
            LISTING_NIGHTLIFE_NYE_TOUCHPOINT.defaultValue,
        );
        setShowTouchpoint(variant == 'show');
    }, []);

    const validNightlifeCategories = [
        EVENTBRITE_CATEGORY_MAPPING[MUSIC_EVENTBRITE_CATEGORY].toString(),
        EVENTBRITE_CATEGORY_MAPPING[
            FOOD_AND_DRINK_EVENTBRITE_CATEGORY
        ].toString(),
        EVENTBRITE_CATEGORY_MAPPING[FILM_EVENTBRITE_CATEGORY].toString(),
        EVENTBRITE_CATEGORY_MAPPING[SEASONAL_EVENTBRITE_CATEGORY].toString(),
    ];
    const validNightlifeSubcategory =
        FORMATTED_SUBCATEGORY_MAP[
            SUBCATEGORY_REFINEMENT_TO_KEY[PERFORMING_EVENTBRITE_CATEGORY][
                'comedy'
            ]
        ]['title'].toString();
    const validNightlifeFormat =
        EVENTBRITE_FORMAT_MAPPING[PARTY_EVENTBRITE_FORMAT].toString();
    // const startHour = new Date(event.start.local).getHours();

    // Checks for valid nightlife categories/subcategory/format and the start time being b/w 8 pm to 12 am
    const isNightlifeEvent =
        (validNightlifeCategories.includes(category || '') ||
            subcategory === validNightlifeSubcategory ||
            format === validNightlifeFormat) &&
        startHour >= 20 &&
        startHour < 24;
    return (
        <>
            {showTouchpoint &&
                (isNightlifeEvent ? (
                    <NightlifePromoBanner />
                ) : (
                    <NYETouchpoint isMobile={isMobile} />
                ))}
        </>
    );
};
